import gql from 'graphql-tag';

export const getMeterReadingValueQuery = gql(/* GraphQL */ `
  query getMeterReadingValue($meterReadingValueId: UUID!) {
    getMeterReadingValue(meterReadingValueId: $meterReadingValueId) {
      id
      meterReadingId
      createdBy
      createdAt
      sourceType
      value
      isArchived
      stepExecutionId
      notes
      taskId
      taskUserFriendlyId
    }
  }
`);
